module.exports = __webpack_public_path__ + "assets/img/3dc966917a3122b19b11614c40be6025.svg";